export default __webpack_public_path__ + "static/media/image.ogo-pay-private-limited.233fcb86.png";